import Styles from './styles.module.scss';

import type { Organization } from '@/features/Shared/model/types/organization.dto';

interface OrganizationNameProps {
	organization?: Organization;
}

export const OrganizationName = ({ organization }: OrganizationNameProps) => {
	return (
		<div className={Styles.organizationNameContainer}>
			<p>{organization?.name ?? 'N/A'}</p>
			<span>{organization?.street_address?.city ?? 'N/A'}</span>
		</div>
	);
};
